import React, { useState } from "react";


import styles from "./Login.module.scss";
import { Mobile } from "../../styles/MediaQuery";
import logo from "../../assets/icons/logo.png";
import kakao from "../../assets/icons/kakaotalk@3x.png";
import google from "../../assets/icons/google@3x.png";

import { InputBar, InputBarWithBtn, TripleInputBar } from "../../components/Common/InputBar";
import { ToggleButton } from "../../components/Common/Button";

export const Login = () => {
  const [userinfo, setUserinfo] = useState({
    isRegister: false,
    name: "",
    nickname: "",
    dob: "",
    /* 0: Male, 1: Female, 2: Unknown */
    gender: 0,
    phone: "",
    artist1: "",
    artist2: "",
    artist3: "",
  });

  const reset = () => {
    setUserinfo({
      isRegister: false,
      name: "",
      nickname: "",
      dob: "",
      /* 0: Male, 1: Female, 2: Unknown */
      gender: 0,
      phone: "",
      artist1: "",
      artist2: "",
      artist3: "",
    })
  }

  const toRegister = () => {
    setUserinfo({
      ...userinfo,
      isRegister: true
    })
  }

  const handleChange = (e) => {
    var filtered = e.target.value.replace(/\s/g,'')
    if(filtered.length > 8) {
      filtered = filtered.slice(0,8)
    }
    setUserinfo({
      ...userinfo,
      [e.target.name]: filtered,
    })
  }

  const randAdj = ['가냘픈', '가는', '가엾은', '가파른', '같은', '거센', '거친', '검은', '게으른', '고달픈', '고른', '고마운', '고운', '고픈', '곧은', '괜찮은', '구석진', '굳은', '굵은', '귀여운', '그런', '그른', '그리운', '기다란', '기쁜', '긴', '깊은', '깎아지른', '깨끗한', '나쁜', '나은', '난데없는', '날랜', '날카로운', '낮은', '너그러운', '너른', '널따란', '넓은', '네모난', '노란', '높은', '누런', '눅은', '느닷없는', '느린', '늦은', '다른', '더러운', '더운', '덜된', '동그란', '돼먹잖은', '된', '둥그런', '둥근', '뒤늦은', '드문', '딱한', '때늦은', '뛰어난', '뜨거운', '막다른', '많은', '매운', '먼', '멋진', '메마른', '메스꺼운', '모난', '못난', '못된', '못생긴', '무거운', '무딘', '무른', '무서운', '미끄러운', '미운', '바람직한', '반가운', '밝은', '밤늦은', '보드라운', '보람찬', '부드러운', '부른', '붉은', '비싼', '빠른', '빨간', '뻘건', '뼈저린', '뽀얀', '뿌연', '새로운', '서툰', '섣부른', '설운', '성가신', '센', '수줍은', '쉬운', '스스러운', '슬픈', '시원찮은', '싫은', '싼', '쌀쌀맞은', '쏜살같은', '쓰디쓴', '쓰린', '쓴', '아니꼬운', '아닌', '아름다운', '아쉬운', '아픈', '안된', '안쓰러운', '안타까운', '않은', '알맞은', '약빠른', '약은', '얇은', '얕은', '어두운', '어려운', '어린', '언짢은', '엄청난', '없는', '여문', '열띤', '예쁜', '올바른', '옳은', '외로운', '우스운', '의심스런', '이른', '익은', '있는', '작은', '잘난', '잘빠진', '잘생긴', '재미있는', '적은', '젊은', '점잖은', '조그만', '좁은', '좋은', '주제넘은', '줄기찬', '즐거운', '지나친', '지혜로운', '질긴', '짓궂은', '짙은', '짠', '짧은', '케케묵은', '큰', '탐스러운', '턱없는', '푸른', '한결같은', '흐린', '희망찬', '흰', '힘겨운']
  const randAnimal = ['고양이', '강아지', '거북이', '토끼', '뱀', '사자', '호랑이', '표범', '치타', '하이에나', '기린', '코끼리', '코뿔소', '하마', '악어', '펭귄', '부엉이', '올빼미', '곰', '돼지', '소', '닭', '독수리', '타조', '고릴라', '오랑우탄', '침팬지', '원숭이', '코알라', '캥거루', '고래', '상어', '칠면조', '직박구리', '쥐', '청설모', '메추라기', '앵무새', '삵', '스라소니', '판다', '오소리', '오리', '거위', '백조', '두루미', '고슴도치', '두더지', '우파루파', '맹꽁이', '너구리', '개구리', '두꺼비', '카멜레온', '이구아나', '노루', '제비', '까치', '고라니', '수달', '당나귀', '순록', '염소', '공작', '바다표범', '들소', '박쥐', '참새', '물개', '바다사자', '살모사', '구렁이', '얼룩말', '산양', '멧돼지', '카피바라', '도롱뇽', '북극곰', '퓨마', '', '미어캣', '코요테', '라마', '딱따구리', '기러기', '비둘기', '스컹크', '돌고래', '까마귀', '매', '낙타', '여우', '사슴', '늑대', '재규어', '알파카', '양', '다람쥐', '담비']

  const randName = () => {
    var idx = Math.floor(Math.random() * randAdj.length);
    var idx2 = Math.floor(Math.random() * randAnimal.length);
    setUserinfo({
      ...userinfo,
      nickname: (randAdj[idx]+randAnimal[idx2])
    })
  }

  const handleToggleChange = (e) => {
    setUserinfo({
      ...userinfo,
      [e.target.getAttribute('name')]: e.target.getAttribute('value'),
    })
  }

  const handleDateChange = (e) => {
    var filtered = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0')
    let result = filtered

    if(userinfo[e.target.name].length == 5 && 
      filtered.length == 4) {
      result = filtered.slice(0,3)
    }
    else if(userinfo[e.target.name].length == 8 && filtered.length == 6) {
      result = filtered.slice(0,4) + "." + filtered.slice(4,5)
    }
    else if(filtered.length < 4) {
      result = filtered
    }
    else if(filtered.length == 4) {
      result = filtered + "."
    }
    else if(filtered.length > 4 && filtered.length < 6) {
      result = filtered.slice(0,4) + "." + filtered.slice(4)
    }
    else if(filtered.length == 6) {
      result = filtered.slice(0,4) + "." + filtered.slice(4) + "."
    }
    else if(filtered.length > 6 && filtered.length < 9) {
      result = filtered.slice(0,4) + "." + filtered.slice(4,6) + "." + filtered.slice(6)
    }
    else {
      result =  filtered.slice(0,4) + "." + filtered.slice(4,6) + "." + filtered.slice(6,8)
    }
    setUserinfo({
      ...userinfo,
      [e.target.name]: result,
    })
  }

  const handlePhoneChange = (e) => {
    var filtered = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1')
    let result = filtered
    if(userinfo[e.target.name].length == 4 && filtered.length == 3) {
      result = filtered.slice(0,2)
    }
    else if(userinfo[e.target.name].length == 9 && filtered.length == 7) {
      result = filtered.slice(0,3) + "-" + filtered.slice(3,6)
    }
    else if(filtered.length < 3) {
      result = filtered
    }
    else if(filtered.length == 3) {
      result = filtered + "-"
    }
    else if(filtered.length > 3 && filtered.length < 7) {
      result = filtered.slice(0,3) + "-" + filtered.slice(3)
    }
    else if(filtered.length == 7) {
      result = filtered.slice(0,3) + "-" + filtered.slice(3) + "-"
    }
    else if(filtered.length > 7 && filtered.length < 11) {
      result = filtered.slice(0,3) + "-" + filtered.slice(3,7) + "-" + filtered.slice(7)
    }
    else {
      result =  filtered.slice(0,3) + "-" + filtered.slice(3,7) + "-" + filtered.slice(7,11)
    }
    setUserinfo({
      ...userinfo,
      [e.target.name]: result,
    })
  }

  const checkSpecial = (str) => {
    const format = /[!-\/:-@[-`{-~\u00A1-\u00A9\u00AB\u00AC\u00AE-\u00B1\u00B4\u00B6-\u00B8\u00BB\u00BF\u00D7\u00F7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u037E\u0384\u0385\u0387\u03F6\u0482\u055A-\u055F\u0589\u058A\u058D-\u058F\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0606-\u060F\u061B\u061E\u061F\u066A-\u066D\u06D4\u06DE\u06E9\u06FD\u06FE\u0700-\u070D\u07F6-\u07F9\u07FE\u07FF\u0830-\u083E\u085E\u0964\u0965\u0970\u09F2\u09F3\u09FA\u09FB\u09FD\u0A76\u0AF0\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0C84\u0D4F\u0D79\u0DF4\u0E3F\u0E4F\u0E5A\u0E5B\u0F01-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F85\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FDA\u104A-\u104F\u109E\u109F\u10FB\u1360-\u1368\u1390-\u1399\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DB\u1800-\u180A\u1940\u1944\u1945\u19DE-\u19FF\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B6A\u1B74-\u1B7C\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2010-\u2027\u2030-\u205E\u207A-\u207E\u208A-\u208E\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2775\u2794-\u2B73\u2B76-\u2B95\u2B98-\u2BC8\u2BCA-\u2BFE\u2CE5-\u2CEA\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u303F\u309B\u309C\u30A0\u30FB\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAA77-\uAA79\uAADE\uAADF\uAAF0\uAAF1\uAB5B\uABEB\uFB29\uFBB2-\uFBC1\uFD3E\uFD3F\uFDFC\uFDFD\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD\u{10100}-\u{10102}\u{10137}-\u{1013F}\u{10179}-\u{10189}\u{1018C}-\u{1018E}\u{10190}-\u{1019B}\u{101A0}\u{101D0}-\u{101FC}\u{1039F}\u{103D0}\u{1056F}\u{10857}\u{10877}\u{10878}\u{1091F}\u{1093F}\u{10A50}-\u{10A58}\u{10A7F}\u{10AC8}\u{10AF0}-\u{10AF6}\u{10B39}-\u{10B3F}\u{10B99}-\u{10B9C}\u{10F55}-\u{10F59}\u{11047}-\u{1104D}\u{110BB}\u{110BC}\u{110BE}-\u{110C1}\u{11140}-\u{11143}\u{11174}\u{11175}\u{111C5}-\u{111C8}\u{111CD}\u{111DB}\u{111DD}-\u{111DF}\u{11238}-\u{1123D}\u{112A9}\u{1144B}-\u{1144F}\u{1145B}\u{1145D}\u{114C6}\u{115C1}-\u{115D7}\u{11641}-\u{11643}\u{11660}-\u{1166C}\u{1173C}-\u{1173F}\u{1183B}\u{11A3F}-\u{11A46}\u{11A9A}-\u{11A9C}\u{11A9E}-\u{11AA2}\u{11C41}-\u{11C45}\u{11C70}\u{11C71}\u{11EF7}\u{11EF8}\u{12470}-\u{12474}\u{16A6E}\u{16A6F}\u{16AF5}\u{16B37}-\u{16B3F}\u{16B44}\u{16B45}\u{16E97}-\u{16E9A}\u{1BC9C}\u{1BC9F}\u{1D000}-\u{1D0F5}\u{1D100}-\u{1D126}\u{1D129}-\u{1D164}\u{1D16A}-\u{1D16C}\u{1D183}\u{1D184}\u{1D18C}-\u{1D1A9}\u{1D1AE}-\u{1D1E8}\u{1D200}-\u{1D241}\u{1D245}\u{1D300}-\u{1D356}\u{1D6C1}\u{1D6DB}\u{1D6FB}\u{1D715}\u{1D735}\u{1D74F}\u{1D76F}\u{1D789}\u{1D7A9}\u{1D7C3}\u{1D800}-\u{1D9FF}\u{1DA37}-\u{1DA3A}\u{1DA6D}-\u{1DA74}\u{1DA76}-\u{1DA83}\u{1DA85}-\u{1DA8B}\u{1E95E}\u{1E95F}\u{1ECAC}\u{1ECB0}\u{1EEF0}\u{1EEF1}\u{1F000}-\u{1F02B}\u{1F030}-\u{1F093}\u{1F0A0}-\u{1F0AE}\u{1F0B1}-\u{1F0BF}\u{1F0C1}-\u{1F0CF}\u{1F0D1}-\u{1F0F5}\u{1F110}-\u{1F16B}\u{1F170}-\u{1F1AC}\u{1F1E6}-\u{1F202}\u{1F210}-\u{1F23B}\u{1F240}-\u{1F248}\u{1F250}\u{1F251}\u{1F260}-\u{1F265}\u{1F300}-\u{1F6D4}\u{1F6E0}-\u{1F6EC}\u{1F6F0}-\u{1F6F9}\u{1F700}-\u{1F773}\u{1F780}-\u{1F7D8}\u{1F800}-\u{1F80B}\u{1F810}-\u{1F847}\u{1F850}-\u{1F859}\u{1F860}-\u{1F887}\u{1F890}-\u{1F8AD}\u{1F900}-\u{1F90B}\u{1F910}-\u{1F93E}\u{1F940}-\u{1F970}\u{1F973}-\u{1F976}\u{1F97A}\u{1F97C}-\u{1F9A2}\u{1F9B0}-\u{1F9B9}\u{1F9C0}-\u{1F9C2}\u{1F9D0}-\u{1F9FF}\u{1FA60}-\u{1FA6D}]/u
    return format.test(str)?"특수문자는 닉네임에 사용할 수 없습니다.":null
  }

  const checkPhone = (str) => {
    var format = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
    return str.length==0||format.test(str)?null:"올바른 휴대전화번호를 입력해주세요."
  }

  const checkDate = (str) => {
    var date = new Date(str);
    var format = /^([1|2])([0-9]{3})\.?([0-9]{2})\.?([0-9]{2})$/;

    return str.length==0||format.test(str)&&date instanceof Date && !isNaN(date.valueOf())?null:"올바른 생년월일을 입력해주세요."
  }

  const btnList = ["남성", "여성", "선택 안 함"]

  return (
    <div className={styles.container}>
      {!userinfo.isRegister?
        /* Login Main Panel */
        (<div className={styles.contents}>
          <div className={styles.main}>
            <img src={logo} alt="logo" className={styles.logo} />
            <div className={styles.titleText}>FAN FEAT MUSIC 참여형 팬덤 플랫폼</div>
            <div className={styles.mainBtns}>
              <div className={styles.googleBtn} onClick={toRegister}>
                <img src={google} alt="google" />
                <span>구글으로 시작하기</span>
              </div>
              <div className={styles.kakaoBtn} onClick={toRegister}>
                <img src={kakao} alt="kakao" />
                <span>카카오톡으로 시작하기</span>
              </div>
            </div>
          </div>
        </div>):
        /* Register Panel */
        (<div className={styles.contents}>
          <div className={styles.main}>
            <div className={styles.mainTitle}>회원정보 입력</div>
            <InputBar label="이름" onChange={handleChange} value={userinfo.name} placeholder="이름을 입력해주세요" name="name" />
            <InputBarWithBtn label="닉네임" onClick={randName} errChk={checkSpecial} onChange={handleChange} value={userinfo.nickname} placeholder="닉네임을 입력해주세요" name="nickname" />
            <InputBar label="나이(생년월일)" errChk={checkDate} onChange={handleDateChange} value={userinfo.dob} placeholder="생년월일을 입력해주세요 (ex. 1995.01.01)" name="dob" />
            <ToggleButton label="성별" btnList={btnList} value={userinfo.gender} 
              onChange={handleToggleChange} highlightBg="#000" highlightColor="#FFF" nonSelectBg="#FFF" nonSelectColor="#848589"
              border="1px #e5e6e8 solid"
            />
            <InputBar label="전화번호" errChk={checkPhone} onChange={handlePhoneChange} value={userinfo.phone} placeholder="전화번호를 입력해주세요" name="phone" />
            <TripleInputBar label="좋아하는 아티스트" onChange={handleChange} value={[userinfo.artist1,userinfo.artist2,userinfo.artist3]} placeholder="순위" name="artist" />
          </div>
          <div className={styles.mainBottom}>
              <div className={styles.prevBtn} onClick={reset}>이전으로</div>
              <div className={styles.completeBtn}>완료</div>
          </div>
        </div>)}
    </div>
  );
};
